import { props } from '@ngrx/store';
import { createActionWithCorrelation } from '@kion/ngrx-helper';
import { Pagination, Product, ProductSearch, ReduxPagination } from '@kion/data-models';

export const loadAllSuccess = createActionWithCorrelation(
  "[Product] loadAll Success",
  props<{ products: Product[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[Product] loadAll Error",
  props<{ error: any }>()
);
export const loadAll = createActionWithCorrelation(
  "[Product] loadAll",
  loadAllSuccess.type,
  loadAllError.type
);

export const searchSuccess = createActionWithCorrelation(
  "[Product] search success",
  props<{ searchResult: ProductSearch }>()
);
export const searchError = createActionWithCorrelation(
  "[Product] search error",
  props<{ error: any }>()
);

export const textSearchSuccess = createActionWithCorrelation(
  "[Product] text search success",
  props<{ textSearchResult: ProductSearch }>()
);
export const textSearchError = createActionWithCorrelation(
  "[Product] text search error",
  props<{ error: any }>()
);
export const textSearch = createActionWithCorrelation(
  "[Product] text search",
  props<{ query?: string, sort?: string, useDefaultPage?: boolean }>(),
  textSearchSuccess.type,
  textSearchError.type
);

export const search = createActionWithCorrelation(
  "[Product] search",
  props<{ query?: string, sort?: string, useDefaultPage?: boolean, textSearch?: boolean }>(),
  searchSuccess.type,
  searchError.type
);

export const loadByIdSuccess = createActionWithCorrelation(
  "[Product] load by id success",
  props<{ product: Product }>()
);
export const loadByIdError = createActionWithCorrelation(
  "[Product] load by id error",
  props<{ error: any }>()
);
export const loadById = createActionWithCorrelation(
  "[Product] load by id",
  props<{ id: string }>(),
  loadByIdSuccess.type,
  loadByIdError.type
);

export const selectProductVariantSuccess = createActionWithCorrelation(
  "[Product] select product variant success",
  props<{ product: Product }>()
);
export const selectProductVariantError = createActionWithCorrelation(
  "[Product] select product variant error",
  props<{ error: any }>()
);
export const selectProductVariant = createActionWithCorrelation(
  "[Product] select product variant",
  props<{ product: Product, variantId: string }>(),
  selectProductVariantSuccess.type,
  selectProductVariantError.type
);

export const loadByIdsSuccess = createActionWithCorrelation(
  "[Product] load by ids success",
  props<{ products: Product[] }>()
);
export const loadByIdsError = createActionWithCorrelation(
  "[Product] load by ids error",
  props<{ error: any }>()
);
export const loadByIds = createActionWithCorrelation(
  "[Product] load by ids",
  props<{ ids: string[] }>(),
  loadByIdsSuccess.type,
  loadByIdsError.type
);

export const updateQuerySuccess = createActionWithCorrelation(
  "[Product] update query success",
  props<{ query: string[], clearAll?: boolean }>()
);
export const updateQueryError = createActionWithCorrelation(
  "[Product] update query error",
  props<{ error: any }>()
);
export const updateQuery = createActionWithCorrelation(
  "[Product] update query",
  props<{ queryPart: string, remove?: boolean, clearAll?: boolean }>(),
  updateQuerySuccess.type,
  updateQueryError.type
);

export const updateSortSuccess = createActionWithCorrelation(
  "[Product] update sort success",
  props<{ sort: string }>()
);
export const updateSortError = createActionWithCorrelation(
  "[Product] update sort error",
  props<{ error: any }>()
);
export const updateSort = createActionWithCorrelation(
  "[Product] update sort",
  props<{ sort: string }>(),
  updateSortSuccess.type,
  updateSortError.type
);

export const updatePerPageSuccess = createActionWithCorrelation(
  "[Product] update perPage success",
  props<{ pagination: ReduxPagination }>()
);
export const updatePerPageError = createActionWithCorrelation(
  "[Product] update perPage error",
  props<{ error: any }>()
);
export const updatePerPage = createActionWithCorrelation(
  "[Product] update perPage",
  props<{ perPage: number }>()
);

export const updatePageSuccess = createActionWithCorrelation(
  "[Product] update Page success",
  props<{ pagination: ReduxPagination }>()
);
export const updatePageError = createActionWithCorrelation(
  "[Product] update Page error",
  props<{ error: any }>()
);
export const updatePage = createActionWithCorrelation(
  "[Product] update Page",
  props<{ page: number }>()
);

export const loadProductReferenceSuccess = createActionWithCorrelation(
  "[Product] load reference success",
  props<{ products: Product[] }>()
);
export const loadProductReferenceError = createActionWithCorrelation(
  "[Product] load reference error",
  props<{ error: any }>()
);
export const loadProductReference = createActionWithCorrelation(
  "[Product] load reference",
  props<{ productId: string, references: string[] }>(),
  loadProductReferenceSuccess.type,
  loadProductReferenceError.type
);

export const setActiveProductSuccess = createActionWithCorrelation(
  "[Product] set active product success",
  props<{ productId: string }>()
);
export const setActiveProductError = createActionWithCorrelation(
  "[Product] set active product error",
  props<{ error: any }>()
);
export const setActiveProduct = createActionWithCorrelation(
  "[Product] set active product",
  props<{ productId: string }>(),
  setActiveProductSuccess.type,
  setActiveProductError.type
);
export const setSearchTermSuccess = createActionWithCorrelation(
  "[Product] set search term success",
  props<{ searchTerm: string }>()
);
export const setSearchTermError = createActionWithCorrelation(
  "[Product] set search term error",
  props<{ error: any }>()
);
export const setSearchTerm = createActionWithCorrelation(
  "[Product] set search term",
  props<{ searchTerm: string }>(),
  setSearchTermSuccess.type,
  setSearchTermError.type
);

export const setNoResultSuccess = createActionWithCorrelation(
  "[Product] set no result success",
  props<{toggle: boolean}>()
);
export const setNoResultError = createActionWithCorrelation(
  "[Product] set no result error"
);
export const setNoResult = createActionWithCorrelation(
  "[Product] set no result",
  props<{toggle: boolean}>(),
  setNoResultSuccess.type,
  setNoResultError.type
);

export const textSearchReset = createActionWithCorrelation(
  "[Product] text search reset",
);
